import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'admin/automationTemplate/trigger';

export function useAdminAutomationTemplateTriggerQuery() {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_QUERY_KEY],
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IAvailableAutomationTrigger[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'admin/automationTemplate/trigger',
				}),
				'GET'
			);
		},
	});
}

export function invalidateAdminAutomationTemplateTriggerQuery() {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
}
